(() => {
  angular
    .module('gm.common.services')
    .factory('gmAuthWatcher', gmAuthWatcherService);

  function gmAuthWatcherService(
    GmyToken,
    btgUser,
    GmyNotifications,
    GmyTransactions,
    promiseCache
  ) {
    'ngInject';

    return {
      startWatchingAuth,
    };

    function startWatchingAuth() {
      GmyToken.onRemove(() => {
        btgUser.clean();
        GmyTransactions.clean();
        GmyNotifications.removeAllEvents();
        GmyNotifications.disconnect();
        promiseCache.removeAll();
      });

      GmyToken.onSet(() => {
        promiseCache.removeAll();
      });
    }
  }
})();
